import { isIntelbrasTenant } from '../isIntelbrasTenant/isIntelbrasTenant';

export const getProName = () => {
  return isIntelbrasTenant() ? 'CVE-Pro' : 'Dash-Pro';
};
